import React from 'react';
import '../spinner/spinner.css';

const Spinner = () => (
  <div className="spinner"></div>
);

export default Spinner;